import type { ScLinkField } from '@core/jss-models';
import type {
  HomeBatteryFunnelSettingsInterface,
  HomeBatteryFunnelStep,
} from '@innogy/feh/models';
import { createNamedFunnelActions } from '@innogy/feh/shared';
import type { GenericProductData } from '@legacy/common-ui-models';
import { createAction, props } from '@ngrx/store';

const feature = 'HomeBattery';
const PREFIX = '[HomeBattery Funnel]';

export const {
  initializeHomeBatteryFunnelStepAction,
  setHomeBatteryFunnelInitializedAction,
  clearHomeBatteryFunnelInitializedAction,
  onHomeBatteryFunnelNavigationAction,
  handleHomeBatteryFunnelPrivateErrorAction,
  handleHomeBatteryFunnelGenericErrorAction,
  toggleHomeBatteryProductSelectionAction,
  confirmHomeBatteryProductSelectionAction,
  resetHomeBatteryProductSelectionAction,
  selectHomeBatteryProductsAction,
  mintHomeBatteryTrackingIdAction,
} = createNamedFunnelActions<
  typeof feature,
  HomeBatteryFunnelStep,
  HomeBatteryFunnelSettingsInterface,
  GenericProductData
>(feature);

export const navigateToOrderFormPageAction = createAction(
  `${PREFIX} Navigate to order form page`,
  props<{ pageData?: ScLinkField }>()
);

export const navigateToStartPageAction = createAction(
  `${PREFIX} Navigate to start form page`,
  props<{ pageData?: ScLinkField }>()
);
